import { Injectable } from '@angular/core';
import { Observable } from "rxjs/Observable";
import { HttpClient } from "@angular/common/http";
import { ResponseModel } from '../models/response.model';
import { GeneralService } from './general.service';
import { HttpParams } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { PersistenceService } from 'angular-persistence';
import { MessageService } from 'primeng/components/common/messageservice';
import { RolePage } from '../models';

@Injectable()
export class PermissionService extends GeneralService {
  constructor(protected httpClient: HttpClient, protected persistenceService: PersistenceService, public messageService: MessageService) {
    super(messageService, httpClient, persistenceService, environment.apiGeneralUrl, "permission");
  }

  public checkPermission(aliasPath: string): Observable<ResponseModel> {
    var params = new HttpParams();
    params = params.append("aliasPath", aliasPath);
    return super.getCustomApi("checkPermission", params);
  }

  public checkPermissionDetail(aliasPath: string, moduleId: any): Observable<ResponseModel> {
    var params = new HttpParams();
    params = params.append("aliasPath", aliasPath);
    params = params.append("moduleId", moduleId);

    return super.getCustomApi("CheckPermissionDetail", params);
  }

  public async checkPermissionAsync(aliasPath: string): Promise<any> {
    let res = await this.checkPermission(aliasPath).toPromise();

    if (res.isSuccess) {
      let data = res.data;
      return data;
    }
    return false;
  }

  public getByRoleId(roleId: any): Observable<ResponseModel> {
    var params = new HttpParams();
    params = params.append("roleId", roleId);
    return super.getCustomApi("getByRoleId", params);
  }

  public updatePermission(rolePages: RolePage[]): Observable<ResponseModel> {
    return super.postCustomApi("updatePermission", rolePages);
  }

}
